import Config from '@/config'
import { CATALOG_CODES } from '@/constants'
import { LANGUAGE_LOCALES_CODE, SEARCH } from '@/constants/ui.constants'
import { getURL } from '@/utils'

// Los locales que puede llevar una URL pública como primer segmento ('es', 'en', 'us'…).
const LOCALES = [...new Set(Object.values(LANGUAGE_LOCALES_CODE))]

export const getVibiaWebUrl = () => getURL(
	Config.getInstance().getConfig('endpoints.vibia-public.url'),
	Config.getInstance().getConfig('endpoints.vibia-public.subdomain')
).replace(/\/$/, '')

/**
 * Resuelve una URL del nav del CMS. Misma regla que el `LinkWrapper` del sitio público: las
 * absolutas se dejan tal cual y a las relativas se les antepone el locale salvo que ya lo
 * traigan (el payload mezcla las dos formas).
 */
export const toPublicHref = (url, locale) => {
	if (!url) return ''
	if (/^(https?:\/\/|www\.)/i.test(url)) return url

	const segments = url.split('/').filter(Boolean)
	const path = LOCALES.includes(segments[0]) ? segments.join('/') : [locale, ...segments].join('/')
	return `${getVibiaWebUrl()}/${path}`
}

/** Página de búsqueda del sitio público, el mismo destino al que navega su propio buscador. */
export const buildSearchUrl = (locale, catalogId, query) => {
	const segments = [locale, CATALOG_CODES[catalogId], SEARCH[locale]].filter(Boolean)
	return `${getVibiaWebUrl()}/${segments.join('/')}?query=${encodeURIComponent(query)}`
}
